import { Notify, LinkNotify, ButtonNotify, NamedLinkNotify } from "./types";

export const isLinkNotify = (n: Notify): n is LinkNotify => {
  return "link" in n;
};

export const isButtonNotify = (n: Notify): n is ButtonNotify => {
  return "button" in n;
};

export const isNamedLinkNotify = (n: Notify): n is NamedLinkNotify => {
  return (
    "link" in n &&
    typeof n.link === "object" &&
    "to" in n.link &&
    typeof n.link.to === "object" &&
    "name" in n.link.to
  );
};
